import React, { useState } from 'react';
import {
  Box, Typography, Chip, Dialog, DialogTitle,
  DialogContent, DialogActions, Button
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './BadgesRecruteur.css';
import badgesList from '../../commun/badgesList';

const BadgesRecruteur = ({ stats }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const badgeData = badgesList.find(b => b.key === stats?.badge);

  if (!badgeData) {
    return <Typography className="no-badge">Aucun badge attribué.</Typography>;
  }

  return (
    <Box className="badges-container">
      <Typography variant="h6" className="badge-title">🎖 Badge principal du recruteur</Typography>

      <Chip
        avatar={<span className="badge-stars">{badgeData.stars}</span>}
        label={badgeData.label}
        color="success"
        onClick={() => setDialogOpen(true)}
        onDelete={() => setDialogOpen(true)}
        deleteIcon={<InfoOutlinedIcon />}
        className="badge-chip"
      />

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{badgeData.label}</DialogTitle>
        <DialogContent>
          <Typography>{badgeData.description}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Fermer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default BadgesRecruteur;
